/**
 * SectorGate (fka EmployerSectorGate) — renders the blocking sector-modal
 * globally for BOTH employers and professionals.
 *
 * Pulls state from SectorContext, so the same modal is opened auto on
 * mount (when sector is missing) AND can be re-triggered manually from
 * any consumer (e.g. SectorStatusBanner on EmployerDashboard).
 *
 * Professionals are NOT gated on /onboarding — the wizard's first step IS
 * the sector choice, so the modal would fight the flow there.
 */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSector } from '../contexts/SectorContext';
import SectorChoiceModal from './SectorChoiceModal';

const EmployerSectorGate = ({ children }) => {
  const { modalOpen, markResolved, role } = useSector();
  const { pathname } = useLocation();

  const suppressed = role === 'professional' && pathname.startsWith('/onboarding');

  return (
    <>
      {children}
      {modalOpen && !suppressed && (
        <SectorChoiceModal open role={role} onSaved={(s) => markResolved(s)} />
      )}
    </>
  );
};

export default EmployerSectorGate;
